import { CLEAR_NOTIFICATIONS } from '../../constants';

const initialState = {
  data: [],
  loading: false,
  error: {},
};

export default function (state = initialState, { type, payload } = {}) {
  switch (type) {
    case CLEAR_NOTIFICATIONS.LOAD:
      return {
        ...state,
        loading: true,
      };
    case CLEAR_NOTIFICATIONS.SUCCESS:
      return {
        ...state,
        loading: false,
        data: payload,
      };
    case CLEAR_NOTIFICATIONS.FAIL:
      return {
        ...state,
        loading: false,
        error: payload,
      };
    default:
      return state;
  }
}
